import {
    GET_REFERRAL_TYPES_REQUEST,
    GET_REFERRAL_TYPES_SUCCESS,
    GET_REFERRAL_TYPES_FAILURE
} from '../actions';
const initialState = {};

const GetReferralTypesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_REFERRAL_TYPES_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_REFERRAL_TYPES_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case GET_REFERRAL_TYPES_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default GetReferralTypesReducer;